/**
 * care-tips.js
 *
 * Shopify metaobject rich-text fields store their content as a JSON AST
 * (e.g. {"type":"root","children":[{"type":"list",...}]}). When output
 * directly in Liquid they render as raw JSON string instead of HTML.
 *
 * This script finds every [data-care-json] element, tries to parse its
 * text content as a Shopify rich-text AST, and replaces it with a proper
 * <ul> bullet list. If the content is already HTML (plain text / already
 * rendered), the JSON.parse will throw and the content is left untouched.
 */
(function () {
  /**
   * Recursively walk a Shopify rich-text AST node and collect the plain
   * text value of every `list-item` node into the `items` array.
   */
  function collectItems(node, items) {
    if (!node) return;

    if (node.type === 'list-item') {
      var text = extractText(node);
      if (text.trim()) items.push(text.trim());
      return; // don't recurse further — text is already harvested
    }

    if (Array.isArray(node.children)) {
      node.children.forEach(function (child) {
        collectItems(child, items);
      });
    }
  }

  /** Recursively concatenate all `text` node values inside a node. */
  function extractText(node) {
    if (!node) return '';
    if (node.type === 'text') return node.value || '';
    if (Array.isArray(node.children)) {
      return node.children.map(extractText).join('');
    }
    return '';
  }

  /** Build a <ul> element from an array of strings. */
  function buildList(items) {
    var ul = document.createElement('ul');
    ul.className = 'care-tips__instructions';
    items.forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      ul.appendChild(li);
    });
    return ul;
  }

  document.querySelectorAll('[data-care-json]').forEach(function (el) {
    var raw = el.textContent.trim();
    if (!raw) return;

    try {
      var ast = JSON.parse(raw);
      var items = [];
      collectItems(ast, items);

      if (items.length > 0) {
        el.innerHTML = '';
        el.appendChild(buildList(items));
      }
    } catch (e) {
      // Content is not JSON — already HTML or plain text, leave as-is.
    }
  });
})();
